import { PaymentStatuses } from "../../../features/billingHistory/billingHistory.types";

export enum Fields {
  ID = "id",
  PLAN = "plan",
  AMOUNT = "amount",
  STATUS = "status",
  DATE = "date",
}

export type TRow = {
  [Fields.ID]: string;
  [Fields.PLAN]: {
    name: string;
    invoiceNumber: string;
    invoiceUrl: string;
  };
  [Fields.AMOUNT]: {
    amount: number;
    currency: string;
  };
  [Fields.DATE]: string;
  [Fields.STATUS]: PaymentStatuses;
};
